"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            // tslint:disable-next-line: class-name
            var _EmptyTreeIndicator = /** @class */ (function (_super) {
                __extends(_EmptyTreeIndicator, _super);
                function _EmptyTreeIndicator() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                _EmptyTreeIndicator.prototype.render = function () {
                    return (React.createElement("div", { className: "list-No-Rows-Indicator" },
                        React.createElement("span", null, this.props.EmptyTreeText)));
                };
                return _EmptyTreeIndicator;
            }(React.Component));
            UI._EmptyTreeIndicator = _EmptyTreeIndicator;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=EmptyTreeIndicator.js.map
